import { DataSourceSelector } from "@/shared/components/visualization/controls/DataSourceSelector";
import { isViewableAsRawMessage } from "@/shared/components/visualization/Panel/predicates";
import { actions, useVizDispatch } from "@/shared/state/visualization";
import { type RawMessagePanelState } from "@/shared/state/visualization";

import { type PanelSettingsSidebarProps } from "../../sidebarContext";
import { BasePanelSettings } from "../BasePanelSettings";
import { SettingsSection } from "../SettingsSection";
import styles from "../SettingsSection.module.css";
import { Spotlight } from "../Spotlight";

export interface RawMessagePanelSettingsSidebarProps
  extends PanelSettingsSidebarProps {
  field?: "Topic";
}

export interface RawMessagePanelSettingsProps
  extends RawMessagePanelSettingsSidebarProps {
  state: RawMessagePanelState;
}

export function RawMessagePanelSettings({
  field,
  spotlightKey,
  state,
}: RawMessagePanelSettingsProps) {
  const vizStateDispatch = useVizDispatch();

  return (
    <BasePanelSettings state={state}>
      <SettingsSection title="Topic">
        <Spotlight
          className={styles.settingContainer}
          spotlightKey={field === "Topic" ? spotlightKey : undefined}
        >
          <DataSourceSelector
            onChange={(messagePathNode) => {
              vizStateDispatch(
                actions.putRawMessagePanelData(
                  state.id,
                  messagePathNode.toTopicData(),
                ),
              );
            }}
            optionFilter={isViewableAsRawMessage}
          />
        </Spotlight>
      </SettingsSection>
    </BasePanelSettings>
  );
}
